<template>
  <div>
    <s-table :data="data" processValue="-">
      <s-table-column
        v-for="col in basicColumns"
        :key="col.prop"
        v-bind="col"
        :width="col.width"
      >
      </s-table-column>
      <s-table-column label="Action" :width="60">
        <template v-slot="scope">
          <s-button
            type="text"
            @click="handleView(scope.row)"
            v-if="scope.row.type === 1 || scope.row.type === 2"
          >
            {{ $i18n('View') }}
          </s-button>
        </template>
      </s-table-column>
    </s-table>
  </div>
</template>

<script lang="ts">
import { switchManager } from '@/entities/switch-manager';
import { Component, Vue } from 'vue-property-decorator';
import { getEnv } from '@/utils/getEnv';
import { reportEvent } from '@shopee/ssc-fe-store-service-utils';

interface SwitchData {
  name: string;
  value: string;
  description: string;
  type: number;
}

@Component
export default class ConfPanel extends Vue {
  data: SwitchData[] = [];

  basicColumns = [
    {
      label: this.$i18n('Name'),
      prop: 'name',
      width: 200,
    },
    {
      label: this.$i18n('Value'),
      prop: 'value',
      width: 50,
    },
    {
      label: this.$i18n('Description'),
      prop: 'description',
      width: 250,
    },
  ];

  timer: any = null;

  mounted() {
    this.loadData();
    this.timer = setInterval(() => {
      this.loadData();
    }, 2000);
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  get opsUrl() {
    const env = getEnv();
    if (env === 'development') {
      return 'https://ops.ssc.test.shopeemobile.com/wms/configurationmanagement/configuration/view';
    } else if (env === 'test' || env === 'uat' || env === 'staging') {
      return `https://ops.ssc.${env}.shopeemobile.com/wms/configurationmanagement/configuration/view`;
    } else {
      return 'https://ops.ssc.shopeemobile.com/wms/configurationmanagement/configuration/view';
    }
  }

  get confUrl() {
    const env = getEnv();
    if (env === 'development') {
      return 'https://wms.test.shopeemobile.com/adminportal/configurationManagement/devConfiguration/view';
    } else if (env === 'test' || env === 'uat' || env === 'staging') {
      return `https://wms.${env}.shopeemobile.com/adminportal/configurationManagement/devConfiguration/view`;
    } else {
      return 'https://wms.shopeemobile.com/adminportal/configurationManagement/devConfiguration/view';
    }
  }

  handleView(row: any) {
    reportEvent('click_support_panel_conf_view');
    if (row.type === 1) {
      const url = `${this.opsUrl}?conf_key=${row.name}`;
      window.open(url, '_blank');
    } else if (row.type === 2) {
      const url = `${this.confUrl}?id=${row.name}`;
      window.open(url, '_blank');
    }
  }

  loadData() {
    // 获取全局配置
    // const commonConfKeys = switchManager.getCommonConfKeys();
    // 获取页面配置
    const confKeys = switchManager.getConfKeys();
    this.data = [
      ...Object.entries(confKeys).map(([name, value]) => ({
        name,
        value: value?.conf_value || '',
        description: value?.conf_desc || '',
        type: value?.conf_type || 0,
      })),
      // ...Object.entries(commonConfKeys).map(([name, value]) => ({
      //   name,
      //   value,
      //   scope: this.$i18n('Global') as Scope,
      // })),
    ];
  }
}
</script>

<style scoped>
.conf-panel {
  width: 100%;
  height: 100%;
}
</style>
